import React from "react";

import { Grid } from "@mui/material";

import useStyles from "./styles";

interface MaintenanceTitlePageProps {
  titlePage: string;
  reference?: string;
  customerFullname?: string;
  badge?: React.ReactChild;
}

const MaintenanceTitlePage = ({
  titlePage,
  reference,
  customerFullname,
  badge,
}: MaintenanceTitlePageProps) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className={classes.titleContainer}
    >
      <Grid item xs={12} sm={6} md={6} lg={6} data-cy="title-page-name">
        <span className={classes.title}>{titlePage}</span>
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={6} className={classes.titleDataContainer}>
        {badge && badge}
        <span className={classes.titleData} data-cy="title-page-reference">
          {reference ? ` ${titlePage} #${reference}` : ""}
        </span>
        {reference && customerFullname && (
          <span className={classes.titleData}>&nbsp; | &nbsp;</span>
        )}
        <span className={classes.titleData} data-cy="title-page-customer">
          {customerFullname}
        </span>
      </Grid>
    </Grid>
  );
};

export default MaintenanceTitlePage;
